// extracted by mini-css-extract-plugin
module.exports = {"logoSize":"80px","xsLogoSize":"120px","mdLogoSize":"160px","logos":"logos_logos__mrsLw","logo":"logos_logo__ye_uR","break":"logos_break__2RQ5_"};